import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRolesAction } from "../../../store/actions/role/RolesAction";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import Styles from "./Roles.module.css";
import NoDataFound from "../common/NoDataFound";

const Roles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, message, roles } = useSelector((state) => state.role);

  useEffect(() => {
    dispatch(getRolesAction({}, navigate));
  }, [dispatch]);

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Roles</Link>
          </li>
        </ol>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Roles</h4>
            </div>
            <div className='card-body'>
              <div className='table-responsive ticket-table'>
                <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
                  <div className='table-responsive'>
                    <table id='rolesTable' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                      <thead>
                        <tr>
                          <th className={`${Styles.stickyHeader}`}>Role Name</th>
                          <th>Customers</th>
                          <th>Users</th>
                          <th>Notifications</th>
                          <th>Reports</th>
                          <th>Roles</th>
                          <th>Sales Data</th>
                          {/* <th>Settings</th> */}
                          <th>Transactions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={9} className='text-center'>
                              <ShimmerLoader width='95%' height='20%' count={5} />
                            </td>
                          </tr>
                        ) : roles.length > 0 ? (
                          roles.map((item) => (
                            <tr key={item.role_id}>
                              <td className={`fw-normal ${Styles.stickyBody} `}>{item.role_name}</td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.customers} disabled />
                              </td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.employee_onboard} disabled />
                              </td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.notifications} disabled />
                              </td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.reports} disabled />
                              </td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.roles} disabled />
                              </td>
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.sales_data} disabled />
                              </td>
                              {/* <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.settings} disabled />
                              </td> */}
                              <td className={`text-center ${Styles.custom_tablebody_tr}`}>
                                <input type='checkbox' checked={item.permissions.transactions} disabled />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className={`${Styles.no_hover}`}>
                            <td className={`fs-3 text-center`} colSpan={9}>
                              <NoDataFound width={500} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
